import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=37807a08&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=ts"
export * from "./ReportsTable.vue?vue&type=script&lang=ts"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=37807a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37807a08",
  null
  
)

export default component.exports